import { memo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// The single redesign modal card: glass surface + close button. The enter/exit animation is
// supplied by the host (RedesignModalShell for legacy `modal.show`, the redesign modal
// context for the imperative v2 API). `className` controls width (e.g. `sm:max-w-2xl`).
export const RedesignModalLayout = memo(({ children, className, onClose }) => (<div className={cn(
    // Width defaults: mobile fills the padded overlay (w-full inside the host's p-4, so it never
    // overflows the viewport); desktop fills to max-w (default lg) with a 26rem floor so no modal
    // is too narrow. Modals override the max via `sm:max-w-*` in className.
    'redesign relative flex max-h-[90vh] w-full flex-col items-center gap-6 overflow-auto rounded-2xl border border-solid border-white/[0.08] bg-card p-6 text-foreground shadow-2xl backdrop-blur-xl sm:min-w-[26rem] sm:max-w-lg sm:p-8', className)}>
		{onClose && (<button type="button" aria-label="Close" onClick={onClose} className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground">
				<CloseIcon sx={{ fontSize: 18 }}/>
			</button>)}
		{children}
	</div>));
